import {
  __,
  el,
  ToggleControl,
} from '../../common/variables';
import { cl } from '../../common/functions';

const editGeolocation = (props) => {
  const { className, isSelected, attributes, setAttributes, setMetaValue } = props;
  return el(ToggleControl,
    {
      label: __('Activer la géolocalisation'),
      className: "toggle-box",
      checked: attributes.geolocation,
      onChange: (value) => {
        setAttributes({ geolocation: value });
      }
    }
  )
}

export { editGeolocation }
